import React from "react";
import { USE_CASES, CATEGORIES, MEDIA } from "../../lib/constants";

export const FeaturedContent = () => {
  return (
    <section className="py-24 sm:py-32 bg-[#FAFAFA]" data-testid="featured-content">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-3xl mb-16">
          <div className="text-[10px] uppercase tracking-[0.3em] text-brand mb-5">Find Your Fit</div>
          <h2 className="font-serif text-5xl sm:text-6xl leading-[0.95] tracking-tight">
            Find the right cannabis for <em className="text-brand">your needs</em>.
          </h2>
          <p className="mt-6 text-ink-muted leading-relaxed text-lg">
            Pain relief. Sleep. Stress & anxiety. Our staff helps you match product to purpose —
            no guessing, no stoner-shop sales pitch.
          </p>
        </div>

        {/* Use-case grid */}
        <div className="grid md:grid-cols-3 gap-5 mb-20">
          {USE_CASES.map((u, i) => (
            <article key={u.title} className="group relative p-8 bg-white border border-black/10 hover:border-brand transition-colors overflow-hidden"
                     data-testid={`use-case-${i}`}>
              <div className="flex items-start justify-between mb-8">
                <div className="font-serif text-ink-muted/60 text-3xl">0{i+1}</div>
                <div className="w-12 h-12 rounded-full border border-brand flex items-center justify-center text-brand group-hover:bg-brand group-hover:text-white transition-colors">✦</div>
              </div>
              <h3 className="font-serif text-3xl leading-tight mb-4">{u.title}</h3>
              <p className="text-base text-ink-muted leading-relaxed mb-6">{u.copy}</p>
              <div className="flex flex-wrap gap-2">
                {u.categories.map((c) => (
                  <span key={c} className="text-[10px] uppercase tracking-[0.2em] px-2.5 py-1.5 bg-[#FAFAFA] border border-black/10">{c}</span>
                ))}
              </div>
            </article>
          ))}
        </div>

        {/* Categories bento */}
        <div className="grid md:grid-cols-12 gap-5">
          <div className="md:col-span-5 relative overflow-hidden min-h-[340px] border border-black/10">
            <img src={MEDIA.macroFlower} alt="Macro flower" className="absolute inset-0 w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/90 via-ink/30 to-transparent" />
            <div className="relative h-full flex flex-col justify-end p-8 text-white">
              <div className="text-[10px] uppercase tracking-[0.3em] text-brand mb-2">Featured Category</div>
              <div className="font-serif text-4xl">Small-batch flower.</div>
              <p className="text-white/70 text-sm mt-2 max-w-sm">Hand-trimmed, locally cultivated, lab-tested for purity.</p>
            </div>
          </div>
          <div className="md:col-span-7 grid grid-cols-2 gap-5">
            {CATEGORIES.map((c) => (
              <article key={c.name} className="p-6 sm:p-8 bg-white border border-black/10 hover:border-brand transition-colors" data-testid={`category-${c.name.toLowerCase()}`}>
                <div className="text-[10px] uppercase tracking-[0.3em] text-brand mb-3">Category</div>
                <div className="font-serif text-2xl sm:text-3xl leading-tight">{c.name}</div>
                <p className="text-base text-ink-muted mt-3">{c.copy}</p>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedContent;
